const IGNORED_SEARCH_QUERY_PARAM_KEYS = new Set([
  '_gl',
  'fbclid',
  'gclid',
  'gbraid',
  'mc_cid',
  'mc_eid',
  'msclkid',
  'srsltid',
  'wbraid',
]);

const IGNORED_SEARCH_QUERY_PARAM_PREFIXES = ['utm_'];

export const isIgnoredSearchQueryParam = queryParamName => {
  const normalizedName = `${queryParamName || ''}`.toLowerCase();
  return (
    IGNORED_SEARCH_QUERY_PARAM_KEYS.has(normalizedName) ||
    IGNORED_SEARCH_QUERY_PARAM_PREFIXES.some(prefix => normalizedName.startsWith(prefix))
  );
};

export const getIgnoredSearchQueryParamKeys = params =>
  Object.keys(params || {}).filter(paramName => isIgnoredSearchQueryParam(paramName));

export const stripIgnoredSearchQueryParams = params => {
  return Object.entries(params || {}).reduce((picked, [key, value]) => {
    return isIgnoredSearchQueryParam(key) ? picked : { ...picked, [key]: value };
  }, {});
};
